import { Service } from './Service';

export class CommonService extends Service {

  static entity: string = 'iam-common';

  static getPartyTypes(): Promise<any> {
    return this.axios.get(`${this.entity}/party-types`).then(res => res.data);
  }

  static getProvinces(): Promise<any> {
    return this.axios.get(`${this.entity}/geos/provinces`).then(res => res.data);
  }

  static getCounties(stateProvinceGeoId: string): Promise<any> {
    return this.axios.get(`${this.entity}/geos/${stateProvinceGeoId}/assocs?toGeoTypeEnumId=GEOT_WARD`).then(res => res.data);
  }

  static getPseudoIdFormat(): Promise<any> {
    return this.axios.get(`${this.entity}/agreement-pseudo-id-format`).then(res => res.data);
  }

  static amountToWords(amount): Promise<any> {
    return this.axios.get(`${this.entity}/amount-to-words?amount=${amount}`).then(res => res.data);
  }
  static verificationType(): Promise<any> {
    return this.axios.get(`${this.entity}/verification-type`).then(res => res.data);
  }
  static agreementRoleTypes(): Promise<any> {
    return this.axios.get(`${this.entity}/agreement-role-types`).then(res => res.data);
  }

  static getPartyByTax(partyTaxId: any): Promise<any> {
    return this.axios.get(`iam-party/info/by-tax-code?partyTaxId=${partyTaxId}`).then(res => res.data);
  }

  static getDownloadToolsLink(architecture?: '32bit' | '64bit'): Promise<any> {
    const params = architecture ? { architecture } : {};
    return this.axios.get(`${this.entity}/download-tools-link`, { params }).then(res => res.data);
  }

  static getDocumentTypes(): Promise<any> {
    return this.axios.get(`${this.entity}/oauth2/google/google-doc/document-types`).then(res => res.data);
  }

  static generateDocumentCode(documentType: string): Promise<any> {
    return this.axios.get(`${this.entity}/document/code`, { params: { documentType } }).then(res => res.data);
  }
  
  static getAgreementType(): Promise<any> {
    return this.axios.get(`${this.entity}/agreement-types`).then(res => res.data);
  }
  static getFileTypes(): Promise<any> {
    return this.axios.get(`${this.entity}/file-types`).then(res => res.data);
  }
}
